import { Box, makeUclComponent } from '@rbilabs/universal-components';

import LoadingAnimation from 'components/loading-animation';

export const Loading = makeUclComponent(LoadingAnimation).withConfig<{ $windowHeight?: number }>(
  ({ $windowHeight }) => ({
    ...($windowHeight && { minHeight: $windowHeight - 107 }),
  })
);

export const SpinnerContainer = Box.withConfig({
  justifyContent: 'center',
  height: '100%',
});
